var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import { inject, observer } from 'mobx-react';

import moment from 'moment';

import { Editor } from '../Editor';

var format = function format(time) {
  var h = Math.floor(time / 60);
  var m = ('0' + time % 60).slice(-2);
  return h + ':' + m;
};
export var toDate = function toDate(date, time) {
  var h = Math.floor(time / 60);
  var m = ('0' + time % 60).slice(-2);
  return moment(date).hours(h).minutes(m).toDate();
};
export var fromDate = function fromDate(date) {
  var mom = moment(date);
  return 60 * mom.hours() + mom.minutes();
};
export var parse = function parse(value) {
  if (value.indexOf(':') > 0) {
    var parts = value.split(':');
    return 60 * parseInt(parts[0], 10) + parseInt(parts[1], 10);
  } else if (value.length < 3) return value * 60;else return 60 * Math.floor(value / 100) + value % 100;
};

export var TimeFormatter = function TimeFormatter(_ref) {
  var time = _ref.time,
      _ref$as = _ref.as,
      T = _ref$as === undefined ? 'div' : _ref$as;
  return time ? React.createElement(
    T,
    { style: { paddingTop: '0.25em', marginTop: '1px' } },
    format(time)
  ) : null;
};
export var TimeCellEditor = function TimeCellEditor(_ref2) {
  var cell = _ref2.cell,
      update = _ref2.update;
  return React.createElement(
    Editor,
    { contentEditable: true, suppressContentEditableWarning: true,
      onFocus: function onFocus(e) {
        window.getSelection().selectAllChildren(e.target);
      },
      onBlur: function onBlur(e) {
        var _extends2;

        var field = cell.column.id;
        var value = parse(e.target.textContent);

        update(_extends({}, cell.original, (_extends2 = {}, _extends2[field] = value, _extends2)));
      }
    },
    cell.value && format(cell.value)
  );
};

export var TimeFieldEditor = inject('store')(observer(function (_ref3) {
  var store = _ref3.store,
      field = _ref3.field;
  return React.createElement(
    Editor,
    { contentEditable: true, suppressContentEditableWarning: true,
      onFocus: function onFocus(e) {
        window.getSelection().selectAllChildren(e.target);
      },
      onBlur: function onBlur(e) {
        var value = parse(e.target.textContent);
        store.updateField(field, value);
      }
    },
    store.selected[field] && format(store.selected[field])
  );
}));